define('views/blocks/AuthentificationView',['underscore', 'backbone', 'jquery', 'router', 'app', 'SubView',
        'TagCommander',
        'phoneUtils',
        'WidgetCollectionView',
        'template!blocks/account/authentification',
        'views/blocks/OptinRgpdView',
        'InputView',
        'InputPhoneView',
        'testEmail', 'moment', 'hooks'
    ],

    function (_, Backbone, $, router, app, SubView,
              TagCommander,
              phoneUtils,
              WidgetCollectionView,
              authentificationTemplate,
              OptinRgpdView,
              InputView,
              InputPhoneView,
              testEmail,moment, hooks) {

        var auth2,password,
            googleApiCallback,
            translationContext = 'Account';

        var FB = false, gapi;

        function StartFacebookApp(facebook){
            FB = facebook;
            FB.init({
                appId: app.c('_FACEBOOK_APP_ID_WEB_'),
                cookie: true,
                status: true,
                version: app.c('_FACEBOOK_APP_VERSION_')
            });
            if(!app.isFacebookDisabled()){
                $('.btn-facebook-connect').trigger('facebookEnabled');
            }
        }

        function StartGooglePlatform(googleApi){
            gapi = googleApi;
            if(googleApiCallback) googleApiCallback();
            $('.btn-google-connect').trigger('googleEnabled');
        }

        app.once('hooksStarted',function(){
            // quand l'app a démarré on charge facebook et Google

            // Si le SDK est déjà chargé, on utilise le SDK
            if(window.FB && window.FB.init) return StartFacebookApp(window.FB);

            // Sinon on le charge
            if(!app.isFacebookDisabled()){
                require(['facebook'],StartFacebookApp,function(err){
                });
            }

            //
            require(['googlePlatform'],StartGooglePlatform,function(err){
            });

            //
        });

        function disabledButtonConnect(view,type,enable){
            var btn = view.$('.btn-'+type+'-connect'), icon = btn.find('i');
            enable = enable === true;

            function alert(){
                // fix on/off button event not working
                if(!btn.is('.color-disable')) return;
                app.alert({title:app.t('Désolé','UI'),subtitle:app.t('Ce type d’authentification semble bloqué.')});
                btn.attr('disabled',true);
            }

            btn.toggleClass('color-disable',!enable);

            if(!enable) {
                // désactive le bouton
                icon.attr('class','').text(app.t('Indisponible','UI'));
                btn.on('click',alert);
                // gère la réactivation du bouton facebook
                btn.one(type+'Enabled',function(){
                    disabledButtonConnect(view,type,true);
                });
            }else{
                // réactive le bouton
                if(type == 'facebook'){
                    icon.attr('class','icon-facebook').text('');
                }else{
                    icon.text('G+');
                }
                btn.off('click',alert);
            }
        }

        function getGoogleAuth2(callback) {
            if (auth2) return callback(auth2);
            //
            // TODO : js error fix
            // TypeError: gapi.load is not a function
            //
            try {
                if((!gapi) || (gapi && !_.isFunction(gapi.load))) return app.trigger('googleConnectError');
                //
                gapi.load('auth2', function () {

                    // Retrieve the singleton for the GoogleAuth library and set up the client.
                    auth2 = gapi.auth2.init({
                        client_id: app.c('_GOOGLE_API_CONNECT_ID_', '1055568112688-es9euq5fvjc5ul8c9gvhhlh88peiv1in.apps.googleusercontent.com'),
                        cookiepolicy: 'single_host_origin', // Request scopes in addition to 'profile' and 'email'
                        //scope: 'additional_scope'
                    });

                    //
                    // var isSignedIn = auth2.isSignedIn.get(),
                    // currentUser = auth2.currentUser.get();

                    callback(auth2);

                });
            }catch(err){
                app.error('GoogleAuth2'+err.toString());
                app.trigger('googleConnectError');
            }
        }

        return Backbone.View.extend(SubView).extend({

            events: {
                'submit .authentification-form': 'submitForm',
                'change .action-selector': 'toggleForm',
                'click .btn-facebook-connect': 'facebookConnect',
                'click .btn-google-connect': 'googleConnect',
                'click .reset-password': 'resetPassword',
                'submit .password-reset-form': 'resetSubmit',
            },

            initialize: function (options) {

                // applique les valeurs par défaut en options
                function SetDefault(key,defaultValue){
                    var optionValue;
                    if(options){
                        optionValue = options[key];
                    }
                    view[key] = _(optionValue).isUndefined() ? defaultValue : optionValue;
                }

                var view = this,
                    isComein = !!options.isComein,
                    isComeinEnable = false;
                view.subviews = [];

                SetDefault('theme',''); //
                SetDefault('id',view.cid); //
                SetDefault('register',false); // par défaut l'inscription est inactif
                SetDefault('newsletter',!view.register); // par défaut, newsletter est actif si l'inscription est inactif
                SetDefault('comeinId',false); // par défaut l'inscription est inactif
                SetDefault('flagcomin',false); // par défaut l'inscription est inactif
                view.listenTo(app,"googleConnectError", view.googleConnectError);

                hooks.execHook('IsComeinEnable',null,function(enable){
                    isComeinEnable = enable;
                });
                view.isComein = isComein && isComeinEnable;
                if(options.render){
                    view.render();
                }
                // test les Facebook et google connect
                if(!gapi){
                    disabledButtonConnect(this,'google');
                    googleApiCallback = function(){
                        view.setupGoogleSignin();
                    }
                }else{
                    view.setupGoogleSignin();
                }
                if(!FB || !FB.login || app.isFacebookDisabled()){
                    disabledButtonConnect(this,'facebook');
                }

                if(view.isComein) {
                    hooks.execHook('IsComeinEnable', null, function (IsComeinEnable) {
                        view.isComein = IsComeinEnable;
                    });
                }

            },
            resetPassword: function (e) {
                e.preventDefault();
                var view = this;
                var email = view.$("[name=email]").val();

                if (testEmail(email) == false) {
                    app.banNotice(t('Merci de rentrer un email valide', translationContext));
                    return;
                }
                app.getCustomer().resetPassword({email:email});
            },

            googleConnect: function (e) {
                e.preventDefault();
            },
            googleConnectError: function(e){
                disabledButtonConnect(this,'google');
            },
            getTemplate:function(){
                // alias for override
                return authentificationTemplate;
            },
            render: function () {
             var view = this;

            view.$el.html(view.getTemplate()(view));
                view.setupGoogleSignin();
                if(!FB || !FB.login){
                    disabledButtonConnect(this,'facebook');
                }

                view.attachViews(InputPhoneView.initializeInputsOfView(view));
                view.attachViews(InputView.initializeInputsOfView(view));
                view.delegateEvents();

            },

            getRGPDLink:function() {
                return '<a class="link" href="' + app.c('_RGPD_LINK_') + '">'+ app.c('_RGPD_LINK_TEXT_')+"</a>"
            },

            facebookConnect: function (e) {

                var view = this;
                e.preventDefault();

                function loginFacebook(){
                    view.bindSubmitEvent();
                    view.toggleSubmitLoading(true,'.btn-facebook-connect');
                    app.getCustomer().loginFacebook();
                }

                if(FB && FB.login) {

                    // fix global FB ref bug
                    if(window.FB && window.FB.login) FB = window.FB;

                    try {

                        FB.login(function (response) {
                            if (response.authResponse) {
                                loginFacebook();
                            }
                        }, {scope: 'email,public_profile,user_birthday'});
                    } catch (e) {
                        loginFacebook();
                    }
                }else{
                    disabledButtonConnect(this,'facebook');
                }

            },
            parseForm:function(form){
                var data = {},
                    view = this,
                    formFields = form.serializeArray();
                _(formFields).each(function (field) {
                    var name = field.name;
                    switch(name){
                        case 'phone': data[name] = view.$('[name=phone]').data('E164'); break;
                        default: data[name] = field.value;
                    }
                });
                return data;
            },
            nextStep:function(){},
            submitForm: function (e) {
                e.preventDefault();
                var view = this,
                    form = $(e.currentTarget),
                    data = view.parseForm(form);

                if(view.$('.comein').is('.active')){
                    app.getCustomer().set('email',data.email);
                    hooks.execHook('getAuthentificationComeinPageView',{},function(AuthentificationComeinPageView){
                        var modalView = new AuthentificationComeinPageView();
                        app.displayModal(modalView);
                        modalView.resize();
                    });
                    return;
                }

                if (!data.email) {
                    app.banNotice(t('Merci de rentrer un email valide', translationContext));
                    return;
                }

                if(view.step){
                    // if view is stepped (come in)
                    view.nextStep();
                    return;
                }

                view.toggleSubmitLoading(true);
                if (view.$('.signup').is('.active')) {
                    view.submitRegisterForm(data);
                } else if (view.$('.register-newsletter').is('.active')) {
                    view.submitNewsletterForm(data);
                } else {
                    view.submitLoginForm(data);
                }

            },
            toggleSubmitLoading:function(state,loadingSelector){
                this.$el.toggleClass('locked',!!state);
                this.$('.submit,.btn-google-connect,.btn-facebook-connect').toggleClass('disabled',!!state);
                this.$(loadingSelector || '.submit').attr('disabled',!!state).toggleClass('loading',!!state);
            },
            bindSubmitEvent:function(type){
                var customer = app.getCustomer(),
                    view = this,
                    events = {
                        loginSuccess:view.loginSuccess,
                        login:view.success,
                        loginFail:view.loginFail,
                        registerSuccess:view.registerSuccess,
                        registerFail:view.registerFail
                    };

                _(events).each(function(func,eventName){
                   if(type==='unbind') {
                       view.stopListening(customer,eventName,func);
                   }else{
                       view.listenToOnce(customer,eventName, func);
                   }
                });
            },
            unbindSubmitEvent:function(){
                // alias function
                this.bindSubmitEvent('unbind');
                this.toggleSubmitLoading(false);
            },
            submitLoginForm: function (data) {

                if (data.password == "") {
                    app.banNotice(t('Merci de rentrer votre mot de passe', translationContext));
                    return;
                }
                var view =this, customer = app.getCustomer();
                view.$('button[type="submit"]').addClass('loading').prop("disabled", true);
                password = data.password;
                view.bindSubmitEvent();
                customer.login(data);
            },

            success: function (customer) {
                var view = this;
                view.unbindSubmitEvent();
                view.trigger('success', view);

                if(app.getCustomer().requireRgpdOptin()){
                   return app.displayModal(new OptinRgpdView());
                }
            },
            tcTrack:function(level1,level2){
                TagCommander.tc_ev_gl(this.el,'eventGA',{
                    click_level1:'Compte',
                    click_level2:level1,
                    click_level3:level2
                })
            },
            loginSuccess:function( customer, apiRoute){
                this.tcTrack('Connexion',apiRoute);
            },
            registerSuccess:function( customer, apiRoute){
                this.tcTrack('Création',apiRoute);
            },
            loginFail: function (customer, error, message, data) {
                var view = this;
                view.unbindSubmitEvent();
                view.$('[name=password]').val(password);
                switch(error){
                    default:
                        view.$('.alert-danger').show().html(message);
                }
            },
            submitNewsletterForm: function (data) {
                var view = this;
                view.bindSubmitEvent();
                app.getCustomer().registerNewsletter(data);
            },
            validateForm:function(data, validationLevel){
                var validation = false,
                    birthDay = moment(data.birthday,'DD/MM/YYYY', true),
                    phoneExists = !_.isUndefined(data.phone),
                    now = moment();
                //
                validationLevel = validationLevel >= 0 ? validationLevel : 2; // default validation level
                function banNotice(message){
                    app.banNotice(app.t(message, translationContext));
                }

                if (!_(data.id_customer_comin).isUndefined() && data.id_customer_comin == '') {
                    banNotice("Merci de rentrer votre numéro d'adhérent Come In");
                }else if (_(data.id_gender).isUndefined()) {
                    banNotice('Merci de rentrer votre civilité');
                }else if (!birthDay.isValid() && data.birthday.length >= 0) {
                    banNotice('Merci de rentrer une date de naissance valide');
                }else if (!data.firstname) {
                    banNotice('Merci de rentrer votre prénom');
                }else if (!data.lastname) {
                    banNotice('Merci de rentrer votre nom');
                }else if (phoneExists && !phoneUtils.validate(data.phone)) {
                    banNotice('Merci de rentrer votre numéro de téléphone');
                }else if (now.diff(birthDay, 'years') > 130) {
                    banNotice('Merci de rentrer une date de naissance valide');
                }else if (now.diff(birthDay, 'years') < parseInt(app.c('_MIN_YEAR_FORBIDDEN_', 18))) {
                    banNotice('Vous n\'avez pas l\'âge minimum requis');
                }else if(validationLevel<2){
                    validation = true;
                }else if (data.signupPassword.length < 6) {
                    banNotice('Votre mot de passe doit faire au moins 6 caractères');
                }else if (app.isRGPD() && !data.optin) {
                    banNotice('Merci d’accepter les conditions');
                }else{
                    validation = true;
                }
                return validation;
            },
            submitRegisterForm: function (data) {
                var view = this;
                data.optin = view.$('[name="optin"]').is(':checked') ? 1 : 0;

                if(!view.validateForm(data)){
                    view.toggleSubmitLoading(false);
                    return;
                }

                data.password_v2 = data.signupPassword;

                view.bindSubmitEvent();
                app.getCustomer().register(data);

            },
            registerFail: function () {
                this.unbindSubmitEvent();
                this.$('button[type="submit"]').removeClass('loading').prop("disabled", false);
            },
            toggleForm: function (e) {
                var view = this;
                view.$('.toggle-group').removeClass('active');
                view.$('.toggle-group.' + $(e.currentTarget).val()).addClass('active');

            },
            clickClose: function () {
                this.trigger('close', this);
            },
            setupGoogleSignin: function () {
                var view = this;
                getGoogleAuth2($.proxy(view.attachGoogleSignin, view));
            },
            attachGoogleSignin: function (auth2) {
                var view = this;
                var googleButton = view.$('.color-google').get(0);


                    if(!googleButton){
                        return;
                    }else if (googleButton.googleAttached == true) {
                        return;
                    } else {
                        googleButton.googleAttached = true;
                    }
                    view.$('.btn-google-connect').trigger('googleEnabled');
                    auth2.attachClickHandler(googleButton, {},
                        function (googleUser) {
                            var id_token = googleUser.getAuthResponse().id_token;
                            view.bindSubmitEvent();
                            view.toggleSubmitLoading(true,'.btn-google-connect');
                            app.getCustomer().loginGoogle(id_token);

                        }, function (error) {
                            //alert(JSON.stringify(error, undefined, 2));
                        });

            },

        });

    });

